import * as templateList from '../services/templateList';

export default {
  namespace: 'templateList',

  state: {
    isWmpPage: false,
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    //模板列表
    *getAppIdList({ payload: { values }, callback }, { call, put }) {
      // const isWmpPage = yield select((state) => state.templateList.isWmpPage);
      const requestFun = values.isWmpPage
        ? 'getWmpAccountList'
        : 'getAppIdList';
      const response = yield call(templateList[requestFun], values);
      yield put({
        type: 'save',
        payload: {
          appIdList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //模板列表
    *getWechatTemplateList({ payload: { values }, callback }, { call, put }) {
      // const isWmpPage = yield select((state) => state.templateList.isWmpPage);
      const requestFun = values.isWmpPage
        ? 'getWmpTemplateList'
        : 'getWechatTemplateList';
      const response = yield call(templateList[requestFun], values);
      yield put({
        type: 'save',
        payload: {
          wechatTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //模板消息列表
    *getWechatTemplateMessageList(
      { payload: { values }, callback },
      { call, put },
    ) {
      // const isWmpPage = yield select((state) => state.templateList.isWmpPage);
      const requestFun = values.isWmpPage
        ? 'getWmpTemplateMessageList'
        : 'getWechatTemplateMessageList';
      const response = yield call(templateList[requestFun], values);
      yield put({
        type: 'save',
        payload: {
          wechatTemplateMessageList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除模板消息
    *deleteTemplateMessage({ payload: { values }, callback }, { call }) {
      // const isWmpPage = yield select((state) => state.templateList.isWmpPage);
      const requestFun = values.isWmpPage
        ? 'deleteWmpTemplateMessage'
        : 'deleteTemplateMessage';
      const response = yield call(templateList[requestFun], values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //同步微信模板
    *syncTemplate({ payload: { values }, callback }, { call }) {
      // const isWmpPage = yield select((state) => state.templateList.isWmpPage);
      const requestFun = values.isWmpPage ? 'syncWmpTemplate' : 'syncTemplate';
      const response = yield call(templateList[requestFun], values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (props.pathname === '/miniapps/template_list') {
          dispatch({
            type: 'save',
            payload: {
              isWmpPage: true,
            },
          });
        }
      });
    },
  },
};
